"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultDeserializers = exports.createHeader3Deserializer = exports.createHeader2Deserializer = exports.createHeader1Deserializer = exports.createStrikeDeserializer = exports.createLinkDeserializer = exports.createItalicDeserializer = exports.createBoldDeserializer = void 0;

var lodash_1 = require("lodash");

var htmlSerializer_1 = require("./htmlSerializer");

var createBoldDeserializer = function createBoldDeserializer() {
  return __assign(__assign({}, htmlSerializer_1.createDeserializer({
    nodeName: 'B',
    tagName: htmlSerializer_1.TagName.Text
  })), {
    map: function map() {
      return {
        Bold: true
      };
    }
  });
};

exports.createBoldDeserializer = createBoldDeserializer;

var createItalicDeserializer = function createItalicDeserializer() {
  return __assign(__assign({}, htmlSerializer_1.createDeserializer({
    nodeName: 'I',
    tagName: htmlSerializer_1.TagName.Text
  })), {
    map: function map() {
      return {
        Italic: true
      };
    }
  });
};

exports.createItalicDeserializer = createItalicDeserializer;

var createLinkDeserializer = function createLinkDeserializer(_a) {
  var normalizeHref = (_a === void 0 ? {
    normalizeHref: lodash_1.identity
  } : _a).normalizeHref;
  return __assign(__assign({}, htmlSerializer_1.createDeserializer({
    nodeName: 'A',
    tagName: htmlSerializer_1.TagName.Element
  })), {
    map: function map(element) {
      return {
        type: 'Link',
        data: {
          slatenode: {
            href: normalizeHref(element.getAttribute('href'))
          }
        }
      };
    }
  });
};

exports.createLinkDeserializer = createLinkDeserializer;

var createStrikeDeserializer = function createStrikeDeserializer() {
  return __assign(__assign({}, htmlSerializer_1.createDeserializer({
    nodeName: 'STRIKE',
    tagName: htmlSerializer_1.TagName.Text
  })), {
    map: function map() {
      return {
        StrikeThrough: true
      };
    }
  });
};

exports.createStrikeDeserializer = createStrikeDeserializer;

var createHeader1Deserializer = function createHeader1Deserializer() {
  return __assign({}, htmlSerializer_1.createDeserializer({
    nodeName: 'H1',
    tagName: htmlSerializer_1.TagName.Element
  }));
};

exports.createHeader1Deserializer = createHeader1Deserializer;

var createHeader2Deserializer = function createHeader2Deserializer() {
  return __assign({}, htmlSerializer_1.createDeserializer({
    nodeName: 'H2',
    tagName: htmlSerializer_1.TagName.Element
  }));
};

exports.createHeader2Deserializer = createHeader2Deserializer;

var createHeader3Deserializer = function createHeader3Deserializer() {
  return __assign({}, htmlSerializer_1.createDeserializer({
    nodeName: 'H3',
    tagName: htmlSerializer_1.TagName.Element
  }));
};

exports.createHeader3Deserializer = createHeader3Deserializer;

var createDefaultDeserializers = function createDefaultDeserializers() {
  return {
    Bold: createBoldDeserializer(),
    Italic: createItalicDeserializer(),
    Link: createLinkDeserializer(),
    StrikeThrough: createStrikeDeserializer(),
    Header1: createHeader1Deserializer(),
    Header2: createHeader2Deserializer(),
    Header3: createHeader3Deserializer()
  };
};

exports.createDefaultDeserializers = createDefaultDeserializers;